import { css } from 'styled-components';

const stopMarkerStyles = css`
  .driverMarker {
    font-size: 10px;
    width: 32px;
    height: 32px;
    border-radius: 32px;
    opacity: 1;
    overflow: visible !important;
    background: var(--grey800);
    box-shadow: 0 1px 2px 0 rgba(38, 51, 64, 0.35);

    &__available {
      background: var(--success700);
    }

    &__selected {
      background: var(--primary500);
    }

    &__journeys_number {
      width: 18px;
      height: 18px;
      border-radius: 18px;
      color: var(--grey800);
      font-weight: bold;
      font-size: 12px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: white;
      position: absolute;
      top: -4px;
      left: -4px;
    }
  }
`;

export default stopMarkerStyles;
